import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { HistoricService } from '../../providers/Import/historic.service';
import { AuthentificationService } from '../../providers/Global/authentification.service';

@Component({
  selector: 'app-historic',
  templateUrl: './historic.component.html',
  styleUrls: ['./historic.component.scss']
})
export class HistoricComponent implements OnInit {

  permissions: Array<string> = [];

  @ViewChild('Paginator', {static: false}) paginator: MatPaginator;
  @ViewChild('Sort', {static: false}) sort: MatSort;
  @ViewChild('PaginatorAll', {static: false}) paginatorAll: MatPaginator;
  @ViewChild('SortAll', {static: false}) sortAll: MatSort;

  expanded = false;

  historic: HistoricElement[] = [];
  historicAll: HistoricElement[] = [];

  displayedColumns: string[] = ['date', 'status', 'files', 'actions'];
  historicMatTable;
  historicAllMatTable;

  constructor(private historicService: HistoricService,
              private authentificationService: AuthentificationService,
              private iconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon('edit', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/edit.svg'));
    iconRegistry.addSvgIcon('delete', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/delete.svg'));
    this.permissions = this.authentificationService.permissionsSource.getValue();
  }

  ngOnInit() {
    if (this.permissions.includes('view_historic')) {
      this.getHistoric('true');
    }
    if (this.permissions.includes('view_all_historic')) {
      this.getHistoric('false');
    }

    // this.expanded = true;
  }

  getHistoric(self) {
    if (self === 'true') {
      this.historicService.getHistoric(self)
        .then(res => {
          console.log('historic', res);
          this.historic = [];
          for (const r of res) {
            let i = 0;
            this.historic.push({
              position: r.id_session,
              date: r.datetime_creation,
              files: r.files.split('|').map(obj => {
                const rObj = {};
                rObj['name'] = obj;
                rObj['morename'] = r.filesName.split('|')[i];
                i++;
                return rObj;
              }),
              status: r.statut,
              error: r.error
            });
          }
          delete this.historicMatTable;
          this.historicMatTable = new MatTableDataSource<HistoricElement>(this.historic);
          this.historicMatTable.paginator = this.paginator;
          this.paginator._intl.itemsPerPageLabel = 'Eléments affichés par page';
          this.paginator._intl.nextPageLabel = '';
          this.paginator._intl.previousPageLabel = '';
          this.paginator._intl.firstPageLabel = '';
          this.paginator._intl.lastPageLabel = '';
          this.historicMatTable.sort = this.sort;
          this.historicMatTable.filterPredicate = (data, filter) => {
            let dataStr = '';
            for (const fichier of data.files) {
              dataStr += fichier.name;
            }
            return dataStr.trim().toLowerCase().indexOf(filter) !== -1;
          };
        })
        .catch(err => console.error('historic', err));
    } else {
      this.historicService.getHistoric(self)
        .then(res => {
          console.log('historicAll', res);
          this.historicAll = [];
          for (const r of res) {
            let i = 0;
            this.historicAll.push({
              position: r.id_session,
              date: r.datetime_creation,
              files: r.files.split('|').map(obj => {
                const rObj = {};
                rObj['name'] = obj;
                rObj['morename'] = r.filesName.split('|')[i];
                return rObj;
                i++;
              }),
              status: r.statut,
              error: r.error
            });
          }
          delete this.historicAllMatTable;
          this.historicAllMatTable = new MatTableDataSource<HistoricElement>(this.historicAll);
          this.historicAllMatTable.paginator = this.paginatorAll;
          this.paginatorAll._intl.itemsPerPageLabel = 'Eléments affichés par page';
          this.paginatorAll._intl.nextPageLabel = '';
          this.paginatorAll._intl.previousPageLabel = '';
          this.paginatorAll._intl.firstPageLabel = '';
          this.paginatorAll._intl.lastPageLabel = '';
          this.historicAllMatTable.sort = this.sortAll;
          this.historicAllMatTable.filterPredicate = (data, filter) => {
            let dataStr = '';
            for (const fichier of data.files) {
              dataStr += fichier.name;
            }
            return dataStr.trim().toLowerCase().indexOf(filter) !== -1;
          };
        })
        .catch(err => console.error('historicAll', err));
    }
  }

  applyFilter(filterValue: string, self: 'true' | 'false') {
    if (self === 'true') {
      this.historicMatTable.filter = filterValue.trim().toLowerCase();
    } else {
      this.historicAllMatTable.filter = filterValue.trim().toLowerCase();
    }
  }

  deleteSelfHistoric(element) {
    console.log(element);
    this.historicService.deleteSelfHistoric(element.position)
      .then(res => {
        console.log(res);
        element.status = 2;
      })
      .catch(err => console.log(err));
  }

  /*applyFilter(filterValue: string) {
    // this.historicMatTable.filter = filterValue.trim().toLowerCase();
    this.historicMatTable.filterPredicate = (data, filter) => {
      let dataStr = '';
      for (const fichier of data.fichiers) {
        dataStr += fichier.name;
      }
      return dataStr.indexOf(filter) !== -1;
    };
  }*/
}

export interface HistoricElement {
  position: number;
  date: string;
  files: any[];
  status: number;
  error: number;
}
